import { createHttpsCallableHook } from "./createHttpsCallableHook";
import { ResendRedemptionRequest, ResendRedemptionResponse } from "@t3/shared";

export const useResendRedemption = createHttpsCallableHook<
  ResendRedemptionRequest,
  ResendRedemptionResponse
>("resendRedemption");
